import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { User } from 'app/models/user';
import { Team } from 'app/models/team';
import { WorkflowExec, WorkflowStatus } from 'app/models/workflow-exec';
import { DateRange } from 'app/models/date-range';
import { TeamService } from 'app/services/team.service';
import { UserService } from 'app/services/user.service';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { DateRangeService } from 'app/services/date-range.service';
import { finalize, map, distinct } from 'rxjs/operators';
import { from } from 'rxjs';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { FeatureTrialLockModalComponent } from '../feature-trial-lock-modal/feature-trial-lock-modal.component';
import { MDBModalService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.scss']
})
export class MyTasksComponent implements OnInit, AfterViewInit {

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit: number = 5;
  usersList: User[];
  teamsList: Team[];

  workflowTemplateNames: string[] = [];

  workflowExecs: WorkflowExec[] = [];
  unfilteredWorkflowExecs: WorkflowExec[] = [];

  isLoading: boolean = false;
  isFilterCollapsed: boolean = false;

  workflowNamesFilter: string[];
  workflowExecNamesFilter: string[];
  initiatorUserFilter: User[];
  initiatorTeamFilter: Team[];
  isOverdueFilter: boolean;
  dueOnFilterDateRange: DateRange;
  dateAssignedFilterDateRange: DateRange;

  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('assignedDateRangePicker', { static: true, read: DaterangepickerDirective }) assignedDateRangePicker: DaterangepickerDirective;
  @ViewChild('dueDateRangePicker', { static: true, read: DaterangepickerDirective }) dueDateRangePicker: DaterangepickerDirective;
  
  constructor(private userService: UserService, private teamService: TeamService,
              private workflowExecutionService: WorkflowExecutionService, public dateRangeService: DateRangeService,
              private ecoDocsTitleService: EcoDocsTitleService, private modalService: MDBModalService) { }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle('My Tasks', false);
    this.workflowNamesFilter = [];
    this.workflowExecNamesFilter = [];
    this.initiatorUserFilter = [];
    this.initiatorTeamFilter = [];
    this.isOverdueFilter = false;
    this.dateAssignedFilterDateRange = this.dateRangeService.lastThreeMonths;
    this.dueOnFilterDateRange = this.dateRangeService.lastThreeMonths;
    
    this.teamService.getAll().subscribe(r => {
      this.teamsList = r;
    });

    this.userService.getAll().subscribe(r => {
      this.usersList = r;
    });

    this.isLoading = true;
    this.workflowExecutionService.getMyTasks().pipe(finalize(()=>{
      this.isLoading = false;
    })) .subscribe((w) => {
      this.workflowExecs = w;
      this.unfilteredWorkflowExecs = w;
      this.workflowTemplateNames = [];
      from(this.workflowExecs).pipe(map((w) => w.workflow_template.name), 
                                    distinct()).subscribe((n) => {
                                      this.workflowTemplateNames.push(n);
                                    });

      this.updateFilter();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.assignedDateRangePicker.picker.clear();
      this.dueDateRangePicker.picker.clear();
    }, 1);    
  }

  innerWidth() {
    return window.innerWidth;
  }

  public get workflowStatus() : typeof WorkflowStatus {
    return WorkflowStatus;
  }

  updateFilter() {
    // give angular some time to detect changes to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      const newWorkflows = this.unfilteredWorkflowExecs.filter((w) => {
        return (this.workflowNamesFilter.length == 0 || this.workflowNamesFilter.indexOf(w.workflow_template.name) != -1) &&
        (this.workflowExecNamesFilter.length == 0 || this.workflowExecNamesFilter.indexOf(w.name) != -1) &&
                (this?.dateAssignedFilterDateRange?.startDate == null || (w.assigned_on >= this.dateAssignedFilterDateRange.startDate.toDate() &&
                                              w.assigned_on <= this.dateAssignedFilterDateRange.endDate.toDate())) &&
  
                ( (this.initiatorUserFilter.length == 0 && this.initiatorTeamFilter.length == 0) ||
                  (this.initiatorUserFilter.findIndex(u => u.id == w.initiator_user.id) != -1) ||
                  ((w.initiator_user?.teams?.length && this.initiatorTeamFilter.findIndex(t => w.initiator_user.teams.findIndex(wt => wt.id == t.id) != -1) != -1))
                ) &&
                
                ( 
                  ( 
                    (this.isOverdueFilter && w.due_on <= new Date()) ||
                    (( this.dueOnFilterDateRange == null || this.dueOnFilterDateRange.startDate == null)  ||
                      (w.due_on >= this.dueOnFilterDateRange.startDate.toDate() &&
                      w.due_on <= this.dueOnFilterDateRange.endDate.toDate()))
                  )
                );
      });
  
      this.workflowExecs = newWorkflows;
      
      // Whenever the filter changes, always go back to the first page
      this.table.offset = 0;     
    }, 1);
  }

  checkTrial(event: Event) {
    if (!this.userService.currentUserValue.subscription_status.is_subscribed &&
      !this.userService.currentUserValue.subscription_status.trial_active) {
        event.stopPropagation();
        event.preventDefault();
        event.cancelBubble = true;
        this.modalService.show(FeatureTrialLockModalComponent, {
          ignoreBackdropClick: true,
          backdrop: false,
          animated: true,
          containerClass: 'modal fade',
          class: 'modal-dialog modal-danger modal-notify',
          data: {
          }
        });
    }
  }
}
